import TextArea from "component/atom/forms/text-area/TextArea";
import { FormikProvider, useFormik } from "formik";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import styles from "./CustomMeassage.module.scss";
import * as Yup from "yup";
import Container from "component/atom/container/Container";
import { useFetch } from "hooks/useFetch";
import { companyEndpoints } from "hooks/endpoints";
import Loader from "component/atom/loader/Loader";
import TextEditor from "component/atom/forms/text-editor/TextEditor";

const CustomMessagesTab = forwardRef(({ id, isRefetch }, ref) => {
  const { data, isFetching, refetch } = useFetch(
    ["customMessage", id],
    companyEndpoints.getChatSettings,
    { enabled: true },
    { botId: id }
  );

  const validationSchema = Yup.object({
    customMessage: Yup.string().required("customMessage is Required"),
  });

  const formik = useFormik({
    initialValues: {
      customMessage: data?.data?.customMessage || "",
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {},
  });

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      formik.submitForm();
    },
  }));

  useEffect(() => {
    ref.current = formik;
  }, [ref, formik]);

  useEffect(() => {
    if (isRefetch !== null && isRefetch !== undefined) refetch();
  }, [isRefetch]);

  if (isFetching) {
    return <Loader isComponent />;
  }
  return (
    <FormikProvider value={formik} innerRef={ref}>
      <Container>
        <TextEditor
          label="Customize Reply Message"
          placeholder="your text is inappropriate.."
          name="customMessage"
          value={formik.values.customMessage}
          onChange={(value) => {
            formik.setFieldValue("customMessage", value);
          }}
          error={formik.errors.customMessage}
          touched={formik.touched.customMessage}
          rows="15"
          isToolbarReduced
        />
      </Container>
    </FormikProvider>
  );
});
export default CustomMessagesTab;
